/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["nz-form-explain{margin-bottom:10px;color:#f1736a!important}.hide{display:none}"];
export { styles as styles };
